<template>
  <v-tabs
    class="ui-tabs offer-tabs"
    background-color="transparent"
    :grow="grow"
    v-bind="$attrs"
    :height="height"
    v-on="$listeners"
    v-model="internalValue"
  >
    <v-tab
      v-for="item in tabs"
      :key="item.tab"
      :tab-value="item.tab"
      :disabled="!!item.disabled"
      active-class="text--darken-7"
      class="black--text text--darken-3 px-6"
      :class="tabSmall && 'v-tab-small'"
      @click="onTabClick(item)"
    >
      {{ item.title }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'ui-tabs',
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    tabSmall: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: 40,
    },
    grow: {
      type: Boolean,
      default: false,
    },
    routing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      internalValue: this.value !== undefined
        ? this.value
        : (this.$route?.query?.tab || (this.routing ? this.tabs[0]?.tab : undefined)),
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit('input', val);
    },
    '$route.query.tab': {
      handler(val) {
        if (this.routing && this.value === undefined) {
          this.internalValue = val || this.tabs[0]?.tab;
        }
      },
    },
  },
  mounted() {
    this.$el.addEventListener('wheel', this.handleScroll, {passive: false});
  },
  beforeDestroy() {
    this.$el.removeEventListener('wheel', this.handleScroll);
  },
  methods: {
    onTabClick(item) {
      if (this.routing) {
        const to = item.to || {
          name: this.$route.name,
          query: { ...this.$route.query, tab: item.tab },
          params: { ...this.$route.params },
        };
        this.$router.push(to).catch(() => {});
      } else {
        this.internalValue = item.tab;
      }
    },
    handleScroll(event) {
      event.preventDefault();
      if (event.deltaX !== 0) {
        event.currentTarget.scrollLeft += event.deltaX;
      } else if (event.deltaY !== 0) {
        event.currentTarget.scrollLeft += event.deltaY;
      }
    },
  }
}
</script>

<style lang="scss">
.ui-tabs {
  .v-tab {
    background-color: var(--v-black-lighten6);
    border-radius: 6px 6px 0 0;
    margin-right: 8px;
    overflow: hidden;

    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-transform: none;
  }

  .v-tab-small {
    /*min-width: 80px!important;*/
    color: var(--v-black-darken1);
    font-weight: 500;
    font-size: 12px !important;
    line-height: 18px;
    padding: 8px 12px !important;
    margin-right: 4px !important;
  }

  .v-tab--active {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    background-color: white;
    letter-spacing: inherit;
  }

  .v-tabs-slider-wrapper {
    display: none;
  }
}

.offer-tabs {
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: calc(100% - 50px);
  margin-left: 25px;

  &::-webkit-scrollbar {
    display: none;
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    display: none !important;
  }

  .v-slide-group__wrapper {
    overflow: inherit;

    .v-tab {
      white-space: nowrap;
      margin-right: 5px;
    }

    .v-tab:last-child {
      margin-right: 0;
    }
  }
}
</style>
